import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c1',
        },
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c1',
        },
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c1',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c2',
        },
    ],
};
export const pageConfig = {
    pageProps: {},
    components: [
        {
            name: 'data-management-file-upload',
            key: 'c1',

            props: {
                accept: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv,image/jpeg,image/png,image/jpg,application/pdf',
                placeholder: 'ui.mm.drop-files-details',
            },
        },
        {
            name: 'template-selector',
            key: 'c2',
            props: {},
        },
    ],
};
